import type { DeployedServiceType, LogBasedError, TriageError } from './types';
import { DEFAULT_RUNBOOK_LINK } from './types';

/**
 * Known/triage errors for the supporting backend services (hasura,
 * saml-jackson, supertokens-core), keyed by service.
 *
 * If this grows big we can refactor this out into service specific files.
 */
export const supportingServiceErrors = new Map<
  DeployedServiceType,
  (LogBasedError | TriageError)[]
>([
  [
    'hasura',
    [
      {
        messageContains: 'LIVENESS HTTP probe',
        title: 'Liveness Probe Failed :hasura:',
        threshold: 1,
        priority: 4,
        notionLink: DEFAULT_RUNBOOK_LINK,
      },
      {
        title: 'Hasura 500/502/503/504 Errors',
        jsonContains: {
          'http.status_code': '(500 OR 502 OR 503 OR 504)',
        },
        threshold: 5,
        priority: 3,
        notionLink: DEFAULT_RUNBOOK_LINK,
      },
    ],
  ],
  [
    'saml-jackson',
    [
      {
        messageContains: 'LIVENESS HTTP probe',
        title: 'Liveness Probe Failed :jackson:',
        threshold: 1,
        priority: 4,
        notionLink: DEFAULT_RUNBOOK_LINK,
      },
      {
        messageContains: 'GET /api/auth/signin',
        threshold: 10,
        priority: 4,
        notionLink: DEFAULT_RUNBOOK_LINK,
      },
      {
        title: 'Signin Errors: Web Security Scan',
        jsonContains: {
          'http.url':
            '(*eluve.com/api/auth/signin?error* AND (*web.security.scanner.internal* OR *CODE_POINTS_TO_STRING* OR *NULL+OR+1%3DCAST* OR *UPDATEXML*))',
        },
        threshold: 10,
        priority: 4,
        notionLink: DEFAULT_RUNBOOK_LINK,
      },
    ],
  ],
  [
    'supertokens-core',
    [
      {
        messageContains: 'LIVENESS HTTP probe',
        title: 'Liveness Probe Failed :supertokens:',
        threshold: 1,
        priority: 4,
        notionLink: DEFAULT_RUNBOOK_LINK,
      },
      {
        messageContains: 'POST /public/recipe/signup',
        threshold: 10,
        priority: 4,
        notionLink: DEFAULT_RUNBOOK_LINK,
      },
      {
        messageContains: 'POST https://auth.eluve.com/public/recipe/signinup',
        threshold: 10,
        priority: 4,
        notionLink: DEFAULT_RUNBOOK_LINK,
      },
      {
        messageContains: 'POST https://auth.eluve.com/public/recipe/signup',
        threshold: 10,
        priority: 4,
        notionLink: DEFAULT_RUNBOOK_LINK,
      },
      {
        messageContains: 'POST /api/auth/signup',
        threshold: 10,
        priority: 4,
        ticket: 'ENG-1061',
        notionLink: DEFAULT_RUNBOOK_LINK,
      },
      {
        messageContains: 'POST https://api.eluve.com/api/auth/signinup',
        threshold: 10,
        priority: 4,
        ticket: 'ENG-1061',
        notionLink: DEFAULT_RUNBOOK_LINK,
      },
      {
        messageContains: 'POST https://api.eluve.com/api/auth/session/refresh',
        threshold: 10,
        priority: 4,
        ticket: 'ENG-1061',
        notionLink: DEFAULT_RUNBOOK_LINK,
      },
      {
        messageContains:
          'POST https://auth.eluve.com/recipe/session/refresh 500',
        threshold: 3,
        priority: 4,
        notionLink: DEFAULT_RUNBOOK_LINK,
      },
      {
        messageContains:
          'POST https://auth.siloam.eluve.com/recipe/session/verify 503',
        title: 'Siloam Session Verify 503 Error',
        status: 'error',
        threshold: 3,
        priority: 4,
        ticket: 'ENG-4560',
        notionLink: DEFAULT_RUNBOOK_LINK,
      },
    ],
  ],
]);
